<template>
<div>
  <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
  <pt-detection-corpus-detail class="pt-detection-corpus-detail__withData" v-loading="loading" :corpus="corpus" @handle-loding="handleLoding"></pt-detection-corpus-detail>
</div>

</template>

<script>
import PtDetectionCorpusDetail from './index'
export default {
  name: 'pt-detection-corpus-detail__withData',
  components: {
    'pt-detection-corpus-detail': PtDetectionCorpusDetail
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      // 用于绑定的产品数据对象
      corpus: this.value ? this.value : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false
    }
  },
  methods: {
    // 获取语料
    getCorpus (id) {
      return this.$store.dispatch('getDetectionCorpus', id)
    },
    // 获取检测项名字
    getDetectionName (detectionItemId) {
      return this.$store.dispatch('getDetection', detectionItemId)
    },
    // 加载详情数据
    load () {
      this.loading = true
      this.loadFailed = false
      this.getCorpus(this.id).then((response) => {
        this.corpus = response.data || {}
        return this.getDetectionName(this.corpus.detectionItemId)
      }).then((res) => {
        this.loadFailed = false
        this.loading = false
        this.corpus.detectionItemNameCn = res.data.chineseName
        console.log('corpus', this.corpus)
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        this.$message.error(error)
      })
    },
    handleLoding (val) {
      this.loading = val
    }
  },
  created () {
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    if (!this.order) {
      this.load(_ => {

      })
    }
  }
}
</script>
